<script setup lang="ts">
import type { LocalizedCopy, SiteConfig } from '../types/site'

defineProps<{
  config: SiteConfig
  copy: LocalizedCopy
}>()
</script>

<template>
  <footer id="about" class="app-footer" data-track-section="footer">
    <p>{{ copy.footer.owner }}</p>
    <p>{{ copy.footer.address }}</p>
    <p class="app-footer__contact">
      <span>{{ copy.footer.emailLabel }}：<a :href="`mailto:${config.contact.email}`">{{ config.contact.email }}</a></span>
    </p>
    <p>{{ copy.footer.ageNotice }}</p>
    <div class="app-footer__filings" aria-label="备案信息">
      <p v-for="group in config.filings" :key="group.label">
        <strong>{{ group.label }}：</strong>
        <template v-for="(item, index) in group.items" :key="item.text">
          <span v-if="index" aria-hidden="true"> · </span>
          <a v-if="item.href" :href="item.href" target="_blank" rel="noopener noreferrer">{{ item.text }}</a>
          <span v-else>{{ item.text }}</span>
        </template>
      </p>
    </div>
    <p>{{ copy.footer.copyright }}</p>
    <div class="app-footer__partners" aria-label="合作伙伴">
      <component
        :is="partner.href ? 'a' : 'span'"
        v-for="partner in config.partners"
        :key="partner.id"
        class="app-footer__partner"
        :href="partner.href"
        :target="partner.href ? '_blank' : undefined"
        :rel="partner.href ? 'noopener noreferrer' : undefined"
        :title="partner.name"
        :style="partner.logoScale ? { '--logo-scale': partner.logoScale } : undefined"
      >
        <img v-if="partner.logo" :src="partner.logo" :alt="partner.name" loading="lazy" decoding="async" />
        <template v-else>{{ partner.name }}</template>
      </component>
    </div>
  </footer>
</template>
